import React, { useState, MouseEvent } from 'react';
import * as S from './style';
import { Row, Label } from 'components';
import { AGREEMENT_PRIVACY, AGREEMENT_TEXT } from 'commons/ZimssaString';
export interface Props {
    onClickAgreement: (value: boolean) => void;
    onClickLink: (e: React.MouseEvent<HTMLLabelElement, globalThis.MouseEvent>) => void;
}

function PrivacyAgreement({ onClickAgreement, onClickLink }: Props): React.ReactElement {
    const [checked, setChecked] = useState(false);

    const onClick = (e: React.MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClickAgreement) {
            onClickAgreement(!checked);
        }
        setChecked(!checked);
    };

    const labelProps = {
        fontStyle: 'body2',
        color: 'gray_opacity_800',
        isUnderLine: true,
    };

    return (
        <Row>
            <S.AgreementContainer>
                <S.InputCheck type={'checkbox'} />
                <S.LabelContainer checked={checked} onClick={onClick}>
                    <S.LabelWrapper>
                        {'[필수] '}
                        <Label contents={AGREEMENT_PRIVACY} onClick={onClickLink} {...labelProps} />
                        <Label contents={AGREEMENT_TEXT} fontStyle={'subtitle'} color={'gray_opacity_600'} />
                    </S.LabelWrapper>
                </S.LabelContainer>
            </S.AgreementContainer>
        </Row>
    );
}

export default PrivacyAgreement;
